import * as React from 'react';

// Keep Tab cycling inside an overlay panel; attach to the panel's onKeyDown
export function trapFocus(event: React.KeyboardEvent<HTMLElement>) {
  if (event.key !== 'Tab') return;

  const focusable = event.currentTarget.querySelectorAll<HTMLElement>(
    'input, select, textarea, button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');

  if (focusable.length === 0) {
    event.preventDefault();
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    last.focus();
    event.preventDefault();
  } else if (!event.shiftKey && document.activeElement === last) {
    first.focus();
    event.preventDefault();
  }
}
